import React, { FC, useCallback } from "react";
import {
  LoginRequired,
  LoginRequiredProps,
} from "../components/EmptyState/LoginRequired";
import { usePortalAuth } from "../providers/keycloak-provider";

export const LoginRequiredContainer: FC = () => {
  const { login } = usePortalAuth();

  const action = useCallback(() => {
    login();
  }, [login]);

  const props: LoginRequiredProps = {
    action,
  };

  return <LoginRequired {...props} />;
};
